// url.js
const apiURl = process.env.REACT_APP_API_URL
const baseURl = process.env.REACT_APP_BASE_URL

export { baseURl }
export default apiURl
